import React from 'react';
import { Button, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";


const data = [
    { name: 'Lighting' },
    { name: 'Design' },
    { name: 'Architecture' },
    { name: 'City-planning' },
    { name: 'Furniture' },
    { name: 'Indoor space management' },
    { name: 'Decoration' },
    { name: 'Automotive' },
    { name: 'Road' },
    { name: 'Tunnel' },
    { name: 'Shop design' },
    { name: 'Supermarket' },
    { name: 'Health organization' },
    { name: 'Educational buildings' },
    { name: 'Education' },
    { name: 'E-learning' },
].sort((a, b) => {
    if (a.name < b.name) return (-1)
    if (a.name > b.name) return (1)
    return (0);
}).map((a, index) => ({ ...a, index: index + 1 }));

const renderActivity = (a, { handleClick, modifiers, query }) => {
    if (!modifiers.matchesPredicate)
        return (null);
    const text = `${a.name}`;

    return (
        <MenuItem
            active={modifiers.active}
            disabled={modifiers.disabled}
            key={a.index}
            onClick={handleClick}
            text={text}
        />
    )
}

const predicateActivity = (query, a) => {
    return (`${a.name.toLowerCase()}`.indexOf(query.toLowerCase()) >= 0);
}

class ActivitiesSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activity: null
        }
    }

    handleItemSelect = (activity) => {
        const { onItemSelect } = this.props;

        this.setState({ activity });
        if (!onItemSelect)
            return;
        onItemSelect(activity.name);
    }

    render() {
        const { activity } = this.state;

        return (
            <Select
                className="select-activities"
                items={data}
                itemPredicate={predicateActivity}
                itemRenderer={renderActivity}
                itemDisabled={(a) => a.disable === true}
                onItemSelect={this.handleItemSelect}
                noResults={<MenuItem disabled={true} text="No activiy found..." />}
            >
                <Button
                    fill={true}
                    text={activity ? activity.name : 'Chose activity type'}
                    rightIcon="double-caret-vertical"
                />
            </Select>
        );
    }
}

export { ActivitiesSelect };
